Namespace 'Monitoring.Reports.Publications.Sections'

class Monitoring.Reports.Publications.Sections.PageReachView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/publications/section']

  initialize: (@options = {}, @header = {}) ->
    # just set @options

  render_twitter: ->
    @$el.html(@template({title: @options.title}))
    return this
    
  render: ->
    @$el.html(@template({title: @options.title}))
    return this

  to_utcdate: (string_dates)->
    res= []
    for date in string_dates
      aux = date[0].split("-")
      year = parseInt(aux[0])
      month = parseInt(aux[1]) - 1
      day = parseInt(aux[2])
      res.push( [Date.UTC(year, month,day), date[1] ])
    res

  fill_twitter_page_analytics: (data)->
    new_data = _.map [1, 2, 3], (i) =>
      name = I18n.t("monitoring.dashboard.publications.sections.page.#{data[i][0]}")
      value = @to_utcdate(data[i][1])
      { name: name, data: value }

    if @header.include_page_reach_evolution()
      reach_title = I18n.t('monitoring.dashboard.publications.sections.page_reach_chart_title')
      page_reach_view = new Monitoring.Reports.Publications.Subsections.ChartView(new_data, reach_title)
      @$el.find('.container').append(page_reach_view.render().el)
      
  fill_page_analytics: (data) ->
    new_data = _.map [1, 2, 3], (i) =>
      name = I18n.t("monitoring.dashboard.publications.sections.page.#{data[i][0]}")
      value = @to_utcdate(data[i][1])
      { name: name, data: value }

    if @header.include_page_reach_evolution()
      reach_title = I18n.t('monitoring.dashboard.publications.sections.page_reach_chart_title')
      page_reach_view = new Monitoring.Reports.Publications.Subsections.ChartView(new_data, reach_title)
      @$el.find('.container').append(page_reach_view.render().el)